@if (href) {
  <a
    class="button"
    [class.-disabled]="disabled"
    [routerLink]="disabled ? '' : [href]"
    queryParamsHandling="merge"
    [ngClass]="cssClasses"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="inner"></ng-container>
  </a>
} @else {
  <button class="button" [type]="buttonType" [ngClass]="cssClasses" [disabled]="disabled" (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="inner"></ng-container>
  </button>
}

<ng-template #inner>
  <span class="icon" *ngIf="iconName"><app-icon [name]="iconName"></app-icon></span>
  {{ label }}
</ng-template>
